module.exports = __webpack_public_path__ + "img/bandaoti_juruixing_suoluetu.df9ea0c8.png";